export default /* @ngInject */ ($filter, $sce) => (val) => {
	const abs = Math.abs(val);
	const float = parseFloat(abs);
	const noDecimal = float.toFixed(0);
	let format = $.number(noDecimal, 0, '.', ' ');

	if (val < 0) {
		format = $sce.trustAsHtml(`<span style="color: red;">(${format})</span>`);
	}

	return format;
};
